module.exports = __webpack_public_path__ + "static/media/cal_title.35b28163.png";